import React, {useState} from 'react';
import styled from 'styled-components';
import LocationPreview from '../../../../LocationSelector/components/LocationPreview';
import {DELIVERY, PICKUP} from '../../../../OrderSetting/orderSettingTypes';
import {navigate} from 'gatsby';

const Wrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
  width: 50%;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

function LocationSelector({
  location,
  specialHours,
  changePickUpLocationFromLocationsPage,
  updateOrderSettingModalIsVisible,
  updateInterOrderType,
  currentLocation,
  refine,
  updateSelectedLocation,
  setIsDialogOpen,
  isDialogOpen,
  setSelectedProduct,
}) {
  const [
    idOfExpandedLocationPreview,
    setIdOfExpandedLocationPreview,
  ] = useState(null);

  const [locationToShowOnMobile, setLocationToShowOnMobile] = useState(null);

  const orderFromHere = selectedLocation => {
    if (
      selectedLocation.accepted_order_types.length === 1 &&
      selectedLocation.accepted_order_types[0] === DELIVERY &&
      selectedLocation.accepting_orders
    ) {
      updateInterOrderType(DELIVERY);
    }

    updateInterOrderType(PICKUP);

    if (currentLocation.id !== selectedLocation.id) {
      setSelectedProduct(null);
      updateSelectedLocation(selectedLocation.name);
      setIsDialogOpen(true);
    } else {
      updateOrderSettingModalIsVisible(true);
    }
  };

  return (
    <Wrapper>
      <LocationPreview
        location={location}
        orderFromHere={selectedLocation => orderFromHere(selectedLocation)}
        idOfExpandedLocationPreview={idOfExpandedLocationPreview}
        setIdOfExpandedLocationPreview={id =>
          setIdOfExpandedLocationPreview(id)
        }
        updateOrderSettingModalIsVisible={bool =>
          updateOrderSettingModalIsVisible(bool)
        }
        updateInterOrderType={orderType => updateInterOrderType(orderType)}
        specialHours={specialHours}
        locationToShowOnMobile={locationToShowOnMobile}
        setLocationToShowOnMobile={setLocationToShowOnMobile}
        isOrderButtonHidden
        isChevronHidden
      />
    </Wrapper>
  );
}

export default LocationSelector;
